import { render, staticRenderFns } from "./web-marathon-edit.vue?vue&type=template&id=354ca16d&scoped=true&"
import script from "./web-marathon-edit.vue?vue&type=script&lang=js&"
export * from "./web-marathon-edit.vue?vue&type=script&lang=js&"
import style0 from "./web-marathon-edit.vue?vue&type=style&index=0&id=354ca16d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ca16d",
  null
  
)

export default component.exports